import React from "react";

import ImageOne from "./images/image-one/ImageOne";
import ImageTwo from "./images/image-two/ImageTwo";
import ImageThree from "./images/image-three/ImageThree";
import ImageFour from "./images/image-four/ImageFour";
import ImageFive from "./images/image-five/ImageFive";
import ImageSix from "./images/image-six/ImageSix";
import ImageSeven from "./images/image-seven/ImageSeven";
import EmojiOne from "./emojis/emoji-one/EmojiOne";
import EmojiTwo from "./emojis/emoji-two/EmojiTwo";
import AtlassianOne from "./atlassian/atlassian-one/AtlassianOne";
import AtlassianTwo from "./atlassian/atlassian-two/AtlassianTwo";
import { CARD_DESIGN } from "../../../../settings/features/cards/defaults";

const designComponents = {
  [CARD_DESIGN.IMAGE_ONE]: ImageOne,
  [CARD_DESIGN.IMAGE_TWO]: ImageTwo,
  [CARD_DESIGN.IMAGE_THREE]: ImageThree,
  [CARD_DESIGN.IMAGE_FOUR]: ImageFour,
  [CARD_DESIGN.IMAGE_FIVE]: ImageFive,
  [CARD_DESIGN.IMAGE_SIX]: ImageSix,
  [CARD_DESIGN.IMAGE_SEVEN]: ImageSeven,
  [CARD_DESIGN.EMOJI_ONE]: EmojiOne,
  [CARD_DESIGN.EMOJI_TWO]: EmojiTwo,
  [CARD_DESIGN.ATLASSIAN_ONE]: AtlassianOne,
  [CARD_DESIGN.ATLASSIAN_TWO]: AtlassianTwo,
};

const Design = ({ config, data, isEditable = false }) => {
  const DesignComponent = designComponents[config?.design];

  return (
    <DesignComponent data={data} config={config} isEditable={isEditable} />
  );
};

export default Design;
